export const CRYPTOKITTIES = "0x06012c8cf97BEaD5deAe237070F9587f8E7A266d"
export const CRYPTOPUNKS = "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb"
export const CRYPTOPUNKS_IMAGES = "0x16F5A35647D6F03D5D3da7b35409D65ba03aF3B2"
export const CRYPTOVOXELS = "0x79986aF15539de2db9A5086382daEdA917A9CF0C"
export const DECENTRALAND_ESTATE = "0x959e104E1a4dB6317fA58F8295F586e1A978c297"
export const DECENTRALAND_PARCEL = "0xf87e31492faf9a91b02ee0deaad50d51d56d5d4d"
